import React from 'react'

import { twoDigits } from '../../assets/ts/formatting/formatting'

const CustomTooltip = ({ active, label, payload }: any) => {
    if (!payload) return null

    if (active) {
        if (label === undefined) label = payload[0]?.name

        return (
            <div
                style={{
                    backgroundColor: '#fff',
                    borderRadius: '5px',
                    boxShadow: '0px 0px 5px',
                    padding: '0 3px 0 3px',
                }}>
                <h4 style={{ fontSize: '14px' }}>
                    {label}:{' '}
                    <span style={{ color: `${payload[0]?.fill || payload[0]?.payload?.fill}` }}>
                        {twoDigits(payload[0]?.value)}
                    </span>
                </h4>
            </div>
        )
    }

    return null
}

export default CustomTooltip